import { gql } from "@apollo/client";

export const CREATE_PACIENTE_PROBABLE = gql`
    mutation CreatePacienteProbable(
        $idPrePaciente: Int!,
        $idDelegacion: Int!,        
        $nombre: String!,
        $apellido: String!,
        $idEstado: Int!,
        $codInstitucion: String,
        $sexo: String,
        $edad: Byte,
        $fechaNacimiento: CustomDateTime,
        $idTipoDocumento: Int,
        $nroDocumento: String,
        $telPaciente: String,
        $telFamiliar: String,
        $nombreFamiliar: String,
        $prescripcionPacienteInput: AddPrescripcionPacienteInput,
        $observacion: String,        
        $referente: String,
        $financiador: String, 
        $fechaAltaProbable: CustomDateTime, 
        $idTipoModulo: Int     
        ){
        createPrePaciente(
            input: {
                idPrePaciente: $idPrePaciente,
                idDelegacion: $idDelegacion,
                nombre: $nombre,
                apellido: $apellido,
                idEstado: $idEstado,
                codInstitucion: $codInstitucion,                
                sexo: $sexo,
                edad: $edad,
                fechaNacimiento: $fechaNacimiento,
                idTipoDocumento: $idTipoDocumento,
                nroDocumento: $nroDocumento,
                telPaciente: $telPaciente,
                telFamiliar: $telFamiliar,
                nombreFamiliar: $nombreFamiliar,
                prescripcionPacienteInput: $prescripcionPacienteInput,
                observacion: $observacion,                
                referente: $referente,
                financiador: $financiador,
                fechaAltaProbable: $fechaAltaProbable,
                idTipoModulo: $idTipoModulo
            }
        ) {
            success
            error
            valorEsperado {
                idPrePaciente
            }
        }
    }
`;